<div class="container-fluid">
    <div class="col-12" [formGroup]="reportForm">
        <div class="row">
            <div class="col-3">
                <dx-date-box
                    #startDateBox
                    name="startDate"
                    formControlName="startDate"
                    class="w-100 bds-dx-custom-material"
                    [label]="controlNames && controlNames[0] ? controlNames[0] + '*' : ''"
                    labelMode="floating"
                    type="date"
                    dateSerializationFormat="yyyy-MM-dd"
                    placeholder="mm/dd/yy"
                    displayFormat="MM/dd/yy"
                    [showClearButton]="true"
                    [useMaskBehavior]="true"
                    valueChangeEvent="change blur"
                    (onValueChanged)="onDateChanged('startDate')"
                >
                </dx-date-box>
            </div>
            <div class="col-3">
                <dx-date-box
                    name="endDate"
                    formControlName="endDate"
                    class="w-100 bds-dx-custom-material"
                    [label]="controlNames && controlNames[1] ? controlNames[1] + '*' : ''"
                    labelMode="floating"
                    type="date"
                    dateSerializationFormat="yyyy-MM-dd"
                    placeholder="mm/dd/yy"
                    displayFormat="MM/dd/yy"
                    [showClearButton]="true"
                    [useMaskBehavior]="true"
                    valueChangeEvent="change blur"
                    (onValueChanged)="onDateChanged('endDate')"
                >
                </dx-date-box>
            </div>
            <div class="col-1 d-flex align-items-center justify-content-center">
                <button
                    mat-button
                    class="text-uppercase"
                    color="accent"
                    tabindex="0"
                    [class.mat-button-disabled]="!reportForm.valid"
                    [attr.aria-disabled]="!reportForm.valid"
                    (click)="onGetReportClick()"
                >
                    Get Report
                </button>
            </div>
            <div class="col-1 d-flex align-items-center justify-content-center">
                <button mat-button class="text-uppercase" color="accent" (click)="onCancelClick()">
                    Cancel
                </button>
            </div>
        </div>
        <div class="row" *ngIf="reportForm.errors && reportForm.errors.dateRangeInvalid">
            <mat-error>
                {{ controlNames && controlNames[0] }} must be less than or equal to
                {{ controlNames && controlNames[1] }}
            </mat-error>
        </div>
    </div>
</div>
